"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
// There's something funky with istanbul coverage in this file right now.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPerformerId = getPerformerId;
/* istanbul ignore next */
function getPerformerId(performer) {
    /* istanbul ignore next */
    return performer.hasDetails ? performer.id : null;
}
//# sourceMappingURL=Utilities.js.map